"use strict";

function diffsListToHtmlContentOnly(diffsList) {
  var htmlResult = [];

  function createSpanWord(text, className, startTime) {
    return "<span class='".concat(className, " word' data-start='").concat(startTime, "'>").concat(text, "</span>");
  }

  function createLine(elements, className) {
    return "<span class='".concat(className, " line'>").concat(elements, "</span>");
  }

  diffsList.forEach(function (element) {
    var matchType = element.matchType;

    if (matchType === 'equal') {
      // TODO: do word level - use STT times and text
      var words = element.stt.map(function (w) {
        return createSpanWord(w.text, 'equal', w.start);
      });
      htmlResult.push(words.join(' '));
    }

    if (matchType === 'insert') {
      var _words = element.stt.map(function (w) {
        return createSpanWord(w.text, 'insert', w.start);
      });

      htmlResult.push(_words.join(' '));
    }

    if (matchType === 'delete') {
      var _words2 = element.baseText.map(function (w) {
        return createSpanWord(w, 'delete');
      });

      htmlResult.push(_words2.join(' '));
    }

    if (matchType === 'replace') {
      var wordsStt = element.stt.map(function (w) {
        return createSpanWord(w.text, 'replaceStt', w.start);
      });
      var wordsBaseText = element.baseText.map(function (w) {
        return createSpanWord(w, 'replaceBaseText');
      });
      var wordsSttLine = createLine(wordsStt.join(' '), 'replaceSttLine');
      var baseTextLine = createLine(wordsBaseText.join(' '), 'replaceBaseTextLine');
      var replacedLine = baseTextLine + wordsSttLine;
      htmlResult.push(replacedLine);
    }
  });
  htmlResult = "<div class='text'>".concat(htmlResult.join(' '), "</div>");
  return htmlResult;
}

module.exports.diffsListToHtmlContentOnly = diffsListToHtmlContentOnly;